import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";

/*
 * @Author: menglingze
 * @Date: 2021-12-06 18:10:21
 * @Last Modified by: menglingze
 * @Last Modified time: 2021-12-09 17:09:51
 */
import behaviorTest from '@/utils/behaviorTest';
import { captchaSlideConfig } from './func'; // import OutlineCache from '@/utils/OutlineCache.js'

export var captchaMixin = {
  props: {
    phone: {
      type: String,
      default: ''
    },
    sendVerifyCode: {
      type: Function,
      default: function _default() {}
    },
    loginVerifyCode: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      captcha: '',
      // 验证码
      getCaptchaTime: '',
      // 倒计时
      loginLoading: false // 是否正在登录

    };
  },
  methods: {
    getCaptcha: function getCaptcha() {
      var config = captchaSlideConfig(this.area);
      behaviorTest(config, this.slideSuccess, this.slideError);
    },
    slideSuccess: function slideSuccess(mmvToken) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, _yield$_this$sendVeri, status;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // 调用接口获取验证码
                params = {}; // mobile: this.phone

                _context.next = 3;
                return _this.sendVerifyCode(params, mmvToken);

              case 3:
                _yield$_this$sendVeri = _context.sent;
                status = _yield$_this$sendVeri.status;

                if (status === 1) {
                  _this.countDown();
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    slideError: function slideError() {
      // 错误
      this.$message.warning('错误，请重新获取验证码');
    },
    countDown: function countDown() {
      var _this2 = this;

      this.getCaptchaTime = 60;
      var timeClock = setInterval(function () {
        _this2.getCaptchaTime--;

        if (_this2.getCaptchaTime === 0) {
          clearInterval(timeClock);
          _this2.getCaptchaTime = '';
        }
      }, 1000);
    },
    // 修改密码，判断验证码的接口 async
    submit: function submit() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loginLoading = true;
                params = {
                  verifyCode: _this3.captcha,
                  type: 2 // 修改密码的类型

                };
                _context2.next = 4;
                return _this3.loginVerifyCode(params);

              case 4:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  }
};